module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapbox-container"
  }, [_c('div', {
    staticClass: "mapbox-wrapper"
  }, [_c('div', {
    ref: "mapContainer",
    staticClass: "map"
  }), _vm._v(" "), (_vm.showCountryImages) ? _c('div', {
    staticClass: "map-dark-overlay"
  }) : _vm._e(), _vm._v(" "), (_vm.showCountryImages) ? _c('div', {
    staticClass: "country-images-overlay"
  }, _vm._l((_vm.countries), function(country) {
    return _c('div', {
      key: country.name,
      staticClass: "country-image-wrapper"
    }, [_c('div', {
      staticClass: "title_country"
    }, [_vm._v(" " + _vm._s(country.displayName))]), _vm._v(" "), _c('div', {
      staticClass: "tick_country"
    }, [_c('svg', {
      staticClass: "tick-svg",
      attrs: {
        "viewBox": "0 0 52 52"
      }
    }, [_c('circle', {
      staticClass: "tick-circle",
      attrs: {
        "cx": "26",
        "cy": "26",
        "r": "25",
        "fill": "white"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "tick-check",
      attrs: {
        "fill": "none",
        "d": "M14.1 27.2l7.1 7.2 16.7-16.8"
      }
    })])]), _vm._v(" "), _c('img', {
      staticClass: "country-image",
      style: (country.style),
      attrs: {
        "src": country.image,
        "alt": country.fr
      }
    })])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f54a7a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/mapbox.vue
// module id = 1096
// module chunks = 0